import moment from 'moment';
import { AUTH_ERROR } from 'shared/helper/airbrake';
import { actions as userAction } from 'researcher/user';
import { localStorage } from 'shared/helper/storage';
import request from 'shared/helper/request';
import { translationsForContextAndLanguage } from 'shared/helper/translate';

// import generateCode from 'shared/helper/generate-code';
import * as c from './constants';
export var dismissMessage = function dismissMessage(key) {
  return {
    type: c.MESSAGE_DISMISSED,
    key: key
  };
};
export var applicationLoaded = function applicationLoaded(application, _ref) {
  var error = _ref.error,
    info = _ref.info,
    success = _ref.success,
    warning = _ref.warning;
  return function (dispatch) {
    dispatch({
      type: c.APPLICATION_LOADED,
      application: application,
      cacheUntil: moment().add(10, 'm')
    });
    if (error) {
      dispatch(addMessage({
        type: 'error',
        message: error
      }));
    }
    if (info) {
      dispatch(addMessage({
        type: 'info',
        message: info
      }));
    }
    if (success) {
      dispatch(addMessage({
        type: 'success',
        message: success
      }));
    }
    if (warning) {
      dispatch(addMessage({
        type: 'warning',
        message: warning
      }));
    }
  };
};
export var loadApplication = function loadApplication(_ref2) {
  var error = _ref2.error,
    info = _ref2.info,
    success = _ref2.success,
    warning = _ref2.warning;
  return function (dispatch, getState, _ref3) {
    var application = _ref3.application;
    return new Promise(function (resolve, reject) {
      dispatch(application.get('/api/researcher/load')).then(function (json) {
        if (!json.application) {
          return reject(new Error('Unable to load application'));
        }
        dispatch(applicationLoaded(json.application, {
          error: error,
          info: info,
          success: success,
          warning: warning
        }));
        return resolve(json);
      });
    });
  };
};
export var injectConfiguration = function injectConfiguration(config) {
  return {
    type: c.CONFIGURATION_LOADED,
    config: config
  };
};
export var loadSiteLanguage = function loadSiteLanguage(hrefLanguage, context) {
  return function (dispatch) {
    var urlMatch = window.location.pathname.match(/^\/(cn|en|br|es|jp)\//);
    var urlLanguage = urlMatch ? urlMatch[1] : null;
    var isChinaDomain = window.location.hostname.includes('china');
    var restricted = ['br', 'jp', 'es'];
    if (restricted.includes(urlLanguage)) {
      var newPath = window.location.pathname.replace("/".concat(urlLanguage, "/"), '/en/');
      window.location.replace(newPath);
      return Promise.resolve(); // prevents "Uncaught (in promise)"
    }
    var language = urlLanguage || hrefLanguage || 'en';
    if (isChinaDomain) {
      language = 'cn';
    }
    localStorage.set('language', language);
    return dispatch(updateSiteLanguage(language, context));
  };
};
export var updateSiteLanguage = function updateSiteLanguage(language, context) {
  return function (dispatch, getState, _ref4) {
    var application = _ref4.application;
    dispatch({
      type: c.TRANSLATION_UPDATE_REQUESTED
    });
    localStorage.set('language', language);
    dispatch(application.get('/api/researcher/update-language', {
      language: language
    })).then(function (json) {
      // If the server returns a different language, it means the company in question
      // doesn't support the language attempted by the user. In this instance, we should
      // update our translations / site language to match what's returned
      if (json.siteLanguage !== language) {
        localStorage.set('language', json.siteLanguage);
        dispatch(updateSiteTranslations(context, json.siteLanguage));
      }
    });
    return dispatch(updateSiteTranslations(context, language));
  };
};
export var updateSiteTranslations = function updateSiteTranslations(context, language) {
  return function (dispatch) {
    return translationsForContextAndLanguage(context, language).then(function (translations) {
      return dispatch({
        type: c.TRANSLATIONS_UPDATED,
        translations: translations,
        siteLanguage: language,
        translationContext: context
      });
    });
  };
};
export var addMessage = function addMessage(message) {
  return {
    type: c.MESSAGE_ADDED,
    message: message
    // key: generateCode(20, new Date().getTime()),
  };
};
export var setHeading = function setHeading(heading) {
  return {
    type: c.HEADING_UPDATED,
    heading: heading
  };
};
var networkRequestFailed = function networkRequestFailed() {
  return addMessage({
    modal: true,
    type: 'error',
    message: 'network-request-error',
    action: {
      onClick: function onClick() {
        return window.location.reload();
      }
    }
  });
};

// const handleError = (error) => (dispatch) => {
//     if (error.message === AUTH_ERROR) {
//         dispatch(userAction.invalidateUser());
//     } else {
//         dispatch(networkRequestFailed(error));
//     }

//     throw error;
// };

var handleError = function handleError(error) {
  var skipPopup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch) {
    if (error.message === AUTH_ERROR) {
      dispatch(userAction.invalidateUser());
    } else if (!skipPopup) {
      // Only show popup if skipPopup is false
      dispatch(networkRequestFailed(error));
    }
    throw error;
  };
};

// Add new methods that skip the popup
export var postWithoutPopup = function postWithoutPopup(url, params) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (dispatch) {
    return request.post(url, params, options).catch(function (e) {
      return dispatch(handleError(e, true));
    });
  };
};
export var getWithoutPopup = function getWithoutPopup(url, params) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (dispatch) {
    return request.get(url, params, options).catch(function (e) {
      return dispatch(handleError(e, true));
    });
  };
};
export var get = function get(url, params) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (dispatch) {
    return request.get(url, params, options).catch(function (e) {
      return dispatch(handleError(e));
    });
  };
};
export var put = function put(url, params) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (dispatch) {
    return request.put(url, params, options).catch(function (e) {
      return dispatch(handleError(e));
    });
  };
};
export var post = function post(url, params) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (dispatch) {
    return request.post(url, params, options).catch(function (e) {
      return dispatch(handleError(e));
    });
  };
};
export var del = function del(url, params) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (dispatch) {
    return request.del(url, params, options).catch(function (e) {
      return dispatch(handleError(e));
    });
  };
};
export var req = function req(options) {
  return function (dispatch) {
    return request.req(options).catch(function (e) {
      return dispatch(handleError(e));
    });
  };
};